import { JsonAirport } from './types'

export async function sleep (ms: number) {
  return await new Promise(resolve => setTimeout(resolve, ms))
}

export function differenceInMinutes (date1: number, date2: number): number {
  const diff = date1 - date2
  return Math.floor((diff / 1000) / 60)
}

export function createElement (elementId: string, display?: string): HTMLElement {
  const element = document.createElement('div')
  element.setAttribute('id', elementId)
  element.style.display = display
  return element
}

export async function getAirportData (code: string): Promise<JsonAirport> {
  try {
    const airports = await import('./airports.json')
    return airports.airports.find((rec) => {
      return rec.code === code
    })
  } catch (err) {
    console.warn(err)
    return null
  }
}

export async function getAirports (): Promise<JsonAirport[]> {
  const airports = await import('./airports.json')
  return airports.airports
}

export async function getAircraftName (technicalName: string): Promise<string> {
  const aircraft = await import('./aircraft.json')
  const match = aircraft.aircraft.find((rec) => {
    return rec[0] === technicalName
  })
  return match ? match[1] : technicalName
}

export async function getAirlineName (technicalName: string): Promise<string> {
  const airlines = await import('./airlines.json')
  const match = airlines.airlines.find((rec) => {
    return rec[0] === technicalName
  })
  return match ? match[1] : technicalName
}
